/*******************************************************************************
 * Copyright (c) 2023 Belltane
 *
 * All rights reserved.
 *
 * Contributors:
 *   
 *  Amina Rais - Initial implementation
 *  Version: 1.0.0
 *
 *******************************************************************************/
  
import userReducer from './user/userSlice'
import initializedReducer from './initialized/initializedSlice' 


export const appReducer = {
  
  user: userReducer,  
  initialized: initializedReducer, 
} 